import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';
const ContentCtx = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchContent = useCallback(async (keys = []) => {
    try {
      setLoading(true);
      setError(null);
      const params = keys.length ? `?keys=${encodeURIComponent(keys.join(','))}` : '';
      const res = await fetch(`${API_URL}/api/content${params}`, { credentials: 'include' });
      const data = await res.json();
      if (data?.success && data?.data) {
        setContent(prev => ({ ...prev, ...data.data }));
      } else {
        throw new Error(data?.error || 'Chargement du contenu impossible');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const saveContent = useCallback(async (updates) => {
    const res = await fetch(`${API_URL}/api/content`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ updates }),
    });
    const data = await res.json();
    if (data?.success && data?.data) {
      setContent(prev => ({ ...prev, ...data.data }));
      return { ok: true };
    }
    return { ok: false, error: data?.error || 'Échec de la sauvegarde' };
  }, []);

  useEffect(() => { fetchContent(); }, [fetchContent]);

  const value = { content, loading, error, fetchContent, saveContent };
  return <ContentCtx.Provider value={value}>{children}</ContentCtx.Provider>;
}

export function useContent() {
  const ctx = useContext(ContentCtx);
  if (!ctx) throw new Error('useContent must be used within <ContentProvider>');
  return ctx;
}
